export default "__VITE_ASSET__UHf9vcE5__";